<template>
  <input
      ref="input"
      type="text"
      inputmode="numeric"
      autocomplete="off"
      :value="display"
      :placeholder="placeholder"
      @input="onInput"
      @blur="onBlur"
  >
</template>

<script>
/**
 * Ô nhập số nguyên ≥ 0, tự format hàng nghìn khi gõ: 1000000 → 1.000.000
 * v-model nhận/trả về Number (hoặc null khi trống).
 */
const format = (n) => (n === null || n === undefined || n === '' || Number.isNaN(Number(n)))
    ? '' : Number(n).toLocaleString('vi-VN');

export default {
  name: 'NumberInput',
  props: {
    modelValue: {type: [Number, String], default: null},
    placeholder: {type: String, default: ''},
    max: {type: Number, default: undefined},
  },
  emits: ['update:modelValue'],
  computed: {
    display() {
      return format(this.modelValue);
    },
  },
  methods: {
    onInput(e) {
      const el = e.target;
      const raw = el.value;
      // số chữ số đứng trước con trỏ – để đặt lại con trỏ sau khi format
      const caret = el.selectionStart ?? raw.length;
      const digitsBefore = raw.slice(0, caret).replace(/\D/g, '').length;

      let digits = raw.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
      if (digits.length > 15) digits = digits.slice(0, 15);
      let value = digits === '' ? null : Number(digits);
      if (value !== null && this.max !== undefined && value > this.max) value = this.max;

      this.$emit('update:modelValue', value);

      const text = format(value);
      el.value = text;
      // đặt con trỏ sau đúng số chữ số đã gõ
      let pos = 0, seen = 0;
      while (pos < text.length && seen < digitsBefore) {
        if (/\d/.test(text[pos])) seen++;
        pos++;
      }
      this.$nextTick(() => {
        try { el.setSelectionRange(pos, pos); } catch (err) { /* bỏ qua */ }
      });
    },
    onBlur(e) {
      e.target.value = format(this.modelValue);
    },
  },
};
</script>
